export const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export const trapFocus = (container) => {
  const handler = (event) => {
    if (event.key !== 'Tab') return;

    const focusable = Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR));

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();

      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();

      first.focus();
    }
  };

  container.addEventListener('keydown', handler);

  return () => container.removeEventListener('keydown', handler);
};

export const fadeToggle = ({ wrapper, afterOpen }) => {
  const isHidden = !wrapper.classList.contains('show');

  if (isHidden) {
    wrapper.classList.add('show');

    wrapper.style.opacity = 1;

    if (afterOpen) afterOpen();
  } else {
    wrapper.style.opacity = 0;

    wrapper.classList.remove('show');
  }

  return isHidden;
};

export const slideToggle = ({ content, afterOpen }) => {
  const classes = content.classList;

  classes.contains('show') ? classes.remove('show') : classes.add('show');

  if (afterOpen) afterOpen();
};
